export enum DataSourceFileManifestStatus {
  CONNECTING = 'CONNECTING',
  FILE_DISCOVERY = 'FILE_DISCOVERY',
  PATTERN_RECOGNITION = 'PATTERN_RECOGNITION',
  CONNECTION_FAILED = 'CONNECTION_FAILED',
  MANIFEST_DEFINED = 'MANIFEST_DEFINED',
}
